import ticketInfo from './TicketInfo/ticketInfo'
import ticketMessages from './TicketMessages/ticketMessages'

const components = {
  ticketInfo,
  ticketMessages,
}

export default components
